import { render, staticRenderFns } from "./WatchlistDetailsModal.vue?vue&type=template&id=2ce0316e&scoped=true"
import script from "./WatchlistDetailsModal.vue?vue&type=script&lang=js"
export * from "./WatchlistDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./WatchlistDetailsModal.vue?vue&type=style&index=0&id=2ce0316e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce0316e",
  null
  
)

export default component.exports